(() => {
  const root = document.querySelector("[data-sid-gallery]");
  if (!root) return;

  const main = root.querySelector("[data-sid-main]");
  const thumbs = [...root.querySelectorAll("[data-sid-thumb]")];
  const dialog = root.querySelector("[data-sid-dialog]");
  const stage = root.querySelector("[data-sid-stage]");
  const count = root.querySelector("[data-sid-count]");
  const slides = stage ? [...stage.querySelectorAll(".sid-gallery__slide")] : [];
  const total = slides.length;
  const mobile = window.matchMedia("(max-width: 749px)");

  let index = 0;

  const setIndex = (next, { scroll } = {}) => {
    if (!total) return;
    index = ((next % total) + total) % total;
    const sample = thumbs.find((el) => Number(el.dataset.index) === index);
    if (main && sample) {
      main.src = sample.dataset.src;
      main.alt = sample.dataset.alt || "";
    }
    thumbs.forEach((el) => {
      const on = Number(el.dataset.index) === index;
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-current", on ? "true" : "false");
    });
    if (count) count.textContent = `${index + 1} / ${total}`;
    if (scroll && stage && slides[index]) {
      slides[index].scrollIntoView({ inline: "start", block: "nearest" });
    }
  };

  const open = () => {
    if (!mobile.matches || !dialog) return;
    dialog.showModal();
    requestAnimationFrame(() => setIndex(index, { scroll: true }));
  };

  const close = () => dialog?.close();

  root.querySelector("[data-sid-open]")?.addEventListener("click", open);
  root.querySelector("[data-sid-close]")?.addEventListener("click", close);
  root.querySelector("[data-sid-prev]")?.addEventListener("click", (event) => {
    event.stopPropagation();
    setIndex(index - 1, { scroll: true });
  });
  root.querySelector("[data-sid-next]")?.addEventListener("click", (event) => {
    event.stopPropagation();
    setIndex(index + 1, { scroll: true });
  });

  dialog?.addEventListener("click", (event) => {
    if (event.target === dialog) close();
  });

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", (event) => {
      event.stopPropagation();
      setIndex(Number(thumb.dataset.index), { scroll: dialog?.open });
    });
  });

  if (stage) {
    let ticking = false;
    stage.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const width = stage.clientWidth || 1;
        const next = Math.round(stage.scrollLeft / width);
        if (next !== index) setIndex(next);
      });
    });
  }

  document.addEventListener("keydown", (event) => {
    if (!dialog?.open) return;
    if (event.key === "ArrowRight") setIndex(index + 1, { scroll: true });
    if (event.key === "ArrowLeft") setIndex(index - 1, { scroll: true });
  });
})();
